import type { FinancialHealth } from '@crm/shared';

interface HealthIndicatorsProps {
  health: FinancialHealth;
}

function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function HealthIndicators({ health }: HealthIndicatorsProps) {
  return (
    <div className="bg-white rounded-xl border border-secondary-200 p-5">
      <h3 className="text-sm font-semibold text-secondary-700 mb-4">Indicadores de Saude</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <div>
          <p className="text-xs text-secondary-500 mb-1">Inadimplencia</p>
          <p
            className={`text-lg font-bold ${health.delinquencyRate > 5 ? 'text-red-600' : 'text-secondary-900'}`}
          >
            {health.delinquencyRate.toFixed(1)}%
          </p>
        </div>
        <div>
          <p className="text-xs text-secondary-500 mb-1">LTV Estimado</p>
          <p className="text-lg font-bold text-secondary-900">
            {formatCurrency(health.estimatedLtv)}
          </p>
        </div>
        <div>
          <p className="text-xs text-secondary-500 mb-1">Net Revenue (30d)</p>
          <p
            className={`text-lg font-bold ${health.netRevenue >= 0 ? 'text-green-600' : 'text-red-600'}`}
          >
            {formatCurrency(health.netRevenue)}
          </p>
        </div>
      </div>
    </div>
  );
}
